export interface Category {
  slug: string;
  name: string;
  tagline: string;
  icon: string;
  cover: string;
}

export const categories: Category[] = [
  {
    slug: "rexue",
    name: "热血漫",
    tagline: "一口气追完的爽快燃番",
    icon: "ri-fire-fill",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20and%20energetic%20manga%20cover%20illustration%20featuring%20a%20determined%20young%20hero%20with%20warm%20orange%20and%20caramel%20red%20tones%2C%20dramatic%20action%20pose%2C%20sparkling%20cola%20bubbles%20flying%20in%20the%20background%2C%20stylized%20cartoon%20artwork%20with%20bold%20lines%20and%20clean%20cream%20background&width=800&height=600&seq=cat-rexue&orientation=landscape"
  },
  {
    slug: "gaoxiao",
    name: "搞笑漫",
    tagline: "笑到停不下来的快乐水时刻",
    icon: "ri-emotion-laugh-fill",
    cover: "https://readdy.ai/api/search-image?query=A%20playful%20comedy%20manga%20cover%20with%20an%20exaggerated%20laughing%20cartoon%20character%20holding%20a%20cola%20cup%2C%20bright%20warm%20yellow%20and%20caramel%20tones%2C%20bubbles%20and%20pop%20art%20comic%20effects%2C%20stylized%20cartoon%20illustration%20on%20clean%20cream%20background&width=800&height=600&seq=cat-gaoxiao&orientation=landscape"
  },
  {
    slug: "richang",
    name: "日常漫",
    tagline: "平平淡淡的快乐水日常",
    icon: "ri-cup-fill",
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20slice%20of%20life%20manga%20cover%20with%20a%20relaxed%20character%20sitting%20on%20a%20sofa%20drinking%20cola%20while%20reading%20a%20comic%2C%20soft%20warm%20cream%20and%20tan%20color%20palette%2C%20gentle%20and%20comforting%20cartoon%20illustration%20style&width=800&height=600&seq=cat-richang&orientation=landscape"
  },
  {
    slug: "zhiyu",
    name: "治愈漫",
    tagline: "一口快乐水，治愈一整周",
    icon: "ri-sun-fill",
    cover: "https://readdy.ai/api/search-image?query=A%20soothing%20healing%20manga%20cover%20with%20soft%20warm%20sunlight%2C%20a%20gentle%20cartoon%20character%20enjoying%20a%20cola%20under%20a%20tree%2C%20pastel%20cream%20and%20caramel%20tones%2C%20tender%20and%20calm%20stylized%20illustration&width=800&height=600&seq=cat-zhiyu&orientation=landscape"
  },
  {
    slug: "xuanyi",
    name: "悬疑漫",
    tagline: "深夜可乐站的烧脑推理",
    icon: "ri-magic-fill",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20suspense%20manga%20cover%20with%20moody%20warm%20dark%20caramel%20shadows%2C%20a%20detective%20character%20with%20a%20cola%20bottle%2C%20intriguing%20atmosphere%2C%20stylized%20cartoon%20illustration%20with%20dramatic%20lighting&width=800&height=600&seq=cat-xuanyi&orientation=landscape"
  },
];